import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const usePopperStyles = makeStyles<Theme>(() => ({
  root: {
    zIndex: 999,
    background: 'white',
    borderRadius: '8px',
    border: `1px solid ${colors.G2}`,
    filter: 'drop-shadow(0px 24px 38px rgba(0, 0, 0, 0.2))',
  },
}));

export const styles = css`
  .radius-filter-cta-container {
    display: flex;
    flex-direction: column;
    min-width: 95px;
    height: 41px;
    border-radius: 8px;
    padding: 0 12px;
    margin-left: 8px;
    cursor: pointer;
    white-space: nowrap;
    background-color: white;
  }
  
  .location-filter-cta-container,
  .radius-filter-cta-container,
  .sort-filter-cta-container {
    background: none;
    color: inherit;
    border: none;
    font: inherit;
    outline: inherit;
    text-align: inherit;
  }

  .sort-filter-cta-container, .location-filter-cta-container {
    width: 100%;
  }

  .radius-filter-cta-container:hover {
    background-color: ${colors.G1}
  }

  .radius-filter-cta-header {
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.G3};
    text-transform: uppercase;
  }

  .radius-filter-cta {
    min-width: 80px;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK}
    padding-bottom: 4px;
  }

  .sort-filter-cta-header {
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.G3};
    text-transform: uppercase;
  }

  .sort-filter-cta {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK}
    padding-bottom: 4px;
  }

  .location-filter-cta-header {
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${colors.G3};
    text-transform: uppercase;
  }

  .location-filter-cta {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.2px;
    color: ${colors.BLACK}
    padding-bottom: 4px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
